export default class UserStatus {
	constructor (init = {}) {
		this.status = init.hasOwnProperty('status') ? init.status : null
		this.status_name = init.hasOwnProperty('status_name') ? init.status_name : ''
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/User/UserStatus.js